module.exports = __webpack_public_path__ + "img/tenglong04.b7778a18.png";